import { graphql } from '@/gql';
import type { CreateCoachingAssignmentMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type CreateCoachingAssignmentInput = CreateCoachingAssignmentMutationVariables['input'];

export const createCoachingAssignment = async (params: CreateCoachingAssignmentInput) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateCoachingAssignment($input: CreateCoachingAssignmentInput!) {
        createCoachingAssignment(input: $input) {
          id
          agentId
          operatorId
          createdBy
          startDate
          endDate
        }
      }
    `),
    variables: { input: params },
  });

  return response.data?.createCoachingAssignment;
};
